var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1795 21.6767C25.1575 21.6767 27.7362 20.6086 29.8432 18.5013C31.9501 16.3943 33.0182 13.8163 33.0182 10.838C33.0182 7.86072 31.9501 5.28236 29.8428 3.17471C27.7355 1.06808 25.1572 0 22.1795 0C19.2012 0 16.6232 1.06808 14.5162 3.17505C12.4092 5.28202 11.3408 7.86037 11.3408 10.838C11.3408 13.8163 12.4092 16.3947 14.5166 18.5017C16.6239 20.6083 19.2022 21.6767 22.1795 21.6767Z",
    fill: "#C1C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1441 34.6028C41.0834 33.726 40.9605 32.7695 40.7795 31.7594C40.5969 30.7418 40.3617 29.7798 40.0802 28.9006C39.7894 27.9918 39.3939 27.0944 38.905 26.2343C38.3976 25.3417 37.8016 24.5644 37.1328 23.9248C36.4334 23.2557 35.5772 22.7177 34.587 22.3253C33.6003 21.9349 32.5068 21.7372 31.3371 21.7372C30.8778 21.7372 30.4335 21.9256 29.5755 22.4842C29.0475 22.8286 28.4299 23.2268 27.7405 23.6673C27.151 24.0429 26.3524 24.3948 25.3661 24.7134C24.4037 25.0248 23.4266 25.1827 22.4622 25.1827C21.4978 25.1827 20.5211 25.0248 19.5577 24.7134C18.5724 24.3952 17.7738 24.0433 17.185 23.6677C16.5022 23.2313 15.8842 22.833 15.3482 22.4839C14.4913 21.9253 14.0467 21.7368 13.5873 21.7368C12.4173 21.7368 11.3242 21.9349 10.3378 22.3256C9.34834 22.7173 8.49174 23.2553 7.79171 23.9252C7.12326 24.5651 6.52691 25.342 6.02016 26.2343C5.53162 27.0944 5.13611 27.9915 4.84497 28.9009C4.56379 29.7802 4.32861 30.7418 4.14597 31.7594C3.96503 32.7681 3.84212 33.725 3.78136 34.6039C3.72162 35.4649 3.69141 36.3586 3.69141 37.2612C3.69141 39.6102 4.43813 41.5119 5.91064 42.9143C7.36496 44.2983 9.28928 45.0004 11.6294 45.0004H33.2972C35.6372 45.0004 37.5609 44.2986 39.0155 42.9143C40.4884 41.5129 41.2351 39.6109 41.2351 37.2608C41.2348 36.3541 41.2042 35.4598 41.1441 34.6028Z",
    fill: "#C1C3C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45.0002,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.528719e51a7e776ebef6ef2ab8776de9.svg";
export { ForwardRef as ReactComponent };